// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Q4OvD","header__brand":"styles_header__brand__fmKui"};